<template>

    <!-- <div class="bg-white row items-center full-width" :style="{'border-top': '5px solid '+iconAndBoder}"> -->
    <div class="bg-white row items-center full-width">
        <!-- <div class="col-auto" v-if="icon">
            <div class="q-px-md q-py-sm">
                <div class="row circle column-icon justify-center items-center"
                     :style="{ 'border': '3px solid '+ iconAndBoder, width: '60px', height:'60px'}">
                    <q-icon :name="icon || 'list'" size="2rem" :style="{ color:iconAndBoder  }"></q-icon>
                </div>
            </div>
        </div> -->
        <div class="col q-title text-center q-pa-lg">
            {{ title | capitalize }}
        </div>
        <div class="col-auto" v-if="$slots.right">
            <div class="q-px-md q-py-sm no-wrap row items-center">
                <slot name="right"></slot>
            </div>
        </div>
        <div class="col-12" v-if="$slots.bottom">
            <div class="q-px-md q-py-sm no-wrap row items-center">
                <slot name="bottom"></slot>
            </div>
        </div>
    </div>

</template>


<script>
    // import {QIcon} from 'quasar-framework'

    export default {
        name: 'VHeader',

        props: {
            title: String,
            // titleColor: {
            //     type: String,
            //     default: 'highlight'
            // }
            // icon: String,

            // iconAndBoder: {
            //     type: String,
            //     default: '#E3813B'
            // }
        },

        // components: {
        //     QIcon
        // }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Header.vue